import React, { useEffect, useContext } from 'react';
import { ServiceContext } from 'providers/ServiceProvider';
import { Card } from '@totalsoft/rocket-ui';
import { PAGED_DOCUMENT_TYPES_QUERY } from './queries';
import { useApolloClient } from '@apollo/client';
import { getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import DocumentTypeItem from './DocumentTypeItem';

export const documentTypesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'name',
      caption: 'DocumentTypes.Name',
      type: 'text'
    },
    {
      name: 'code',
      caption: 'DocumentTypes.Code',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'DocumentTypes.Name',
      value: 'Name'
    },
    {
      caption: 'DocumentTypes.Code',
      value: 'Code'
    }
  ],
  pager: {
    orderBy: 'Code',
    direction: 'asc'
  }
});

const DocumentTypeListBrowser = () => {
  const [activeService] = useContext(ServiceContext);
  const client = useApolloClient();

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: PAGED_DOCUMENT_TYPES_QUERY,
        name: 'pagedDocumentTypes'
      }
    }),
    []
  );

  useEffect(() => {
    if (activeService) {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'pagedDocumentTypes' });
      client.cache.gc();
    }
  }, [activeService, client]);

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'DocumentTypes.Code' },
      { name: 'name', caption: 'DocumentTypes.Name' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser name='document-types-browser' store={documentTypesStore} ItemComponent={DocumentTypeItem} columns={columns} />
      <ExportModalComponent store={documentTypesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={documentTypesStore} options={fetchingOptions} />
    </Card>
  );
};

export default DocumentTypeListBrowser;
